import {DocumentType} from '@sollapay/enums';

import {buildDocumentTab} from '@/features/documents';

import type {DocumentUploadTab} from '@/features/documents';
import type {TrustTypeStrategy} from '@sollapay/domain/trust-types';
import type {TFunction} from 'i18next';

/** Optional documents that are "required unless annexed": an entry gives the tab an asterisk plus
 * an explaining tooltip, while the upload stays unenforced. */
const CONDITIONALLY_REQUIRED_DOCUMENT_TOOLTIP_KEYS: Partial<Record<DocumentType, string>> = {
  [DocumentType.TRUSTEE_INSTRUCTIONS]: 'trustAccounts:view.purchases.trusteeInstructionsTooltip'
};

/** Per-buyer upload tabs for the deal type — shared by the add-buyer modal and the buyer page. */
export function buildPurchaseDocumentTabs(
  strategy: TrustTypeStrategy,
  t: TFunction
): DocumentUploadTab[] {
  const requiredTabs = strategy.getRequiredPurchaseDocumentTypes().map(documentType => ({
    ...buildDocumentTab(documentType, t),
    required: true
  }));

  const optionalTabs = strategy.getOptionalPurchaseDocumentTypes().map(documentType => {
    const tooltipKey = CONDITIONALLY_REQUIRED_DOCUMENT_TOOLTIP_KEYS[documentType];
    return {
      ...buildDocumentTab(documentType, t),
      required: !!tooltipKey,
      tooltip: tooltipKey ? t(tooltipKey) : undefined
    };
  });

  return [...requiredTabs, ...optionalTabs];
}
